import { StyledFormField } from '@/components/styles'
import { useFormContext } from 'react-hook-form'
import { useState, useEffect, useRef } from 'react'
import { formErrors } from '@/lib/config'

const FormField = props => {
  const {
    label,
    name,
    validateRules = {},
    inputAs,
    type = 'text',
    inputmode = 'text',
    autoFocus,
    placeholder,
  } = props

  const { errors, getValues, register } = useFormContext()
  const [focused, setFocused] = useState(false)
  const [errorVisible, setErrorVisible] = useState(false)
  const inputRef = useRef()

  useEffect(() => {
    let timeoutId
    if (autoFocus) {
      timeoutId = setTimeout(() => {
        inputRef.current.focus()
      }, 400)
    }

    return () => clearTimeout(timeoutId)
  }, [])

  const error = errors[name]
  const hasError = !!error
  const value = getValues()[name] || ''
  const hasValue = !!value.trim()

  return (
    <StyledFormField focused={focused} hasError={hasError} hasValue={hasValue}>
      <StyledFormField.Label>{label}</StyledFormField.Label>

      <StyledFormField.Input
        as={inputAs}
        name={name}
        type={type}
        inputMode={inputmode}
        ref={e => {
          register(e, validateRules)
          inputRef.current = e
        }}
        onFocus={() => {
          setFocused(true)
        }}
        onBlur={() => {
          setFocused(false)
        }}
        placeholder={placeholder}
      />

      {hasError && (
        <StyledFormField.ErrorIcon
          onMouseEnter={() => {
            setErrorVisible(true)
          }}
          onMouseLeave={() => {
            setErrorVisible(false)
          }}
        />
      )}

      {hasError && (
        <StyledFormField.Error visible={errorVisible}>
          {formErrors[name] ? formErrors[name][error.type] : formErrors.default[error.type]}
        </StyledFormField.Error>
      )}
    </StyledFormField>
  )
}

export default FormField
